import { useMutation } from '@tanstack/react-query';
import { captureException } from '@sentry/react';
import { CustomError } from 'typescript/utilities/custom_error';
import { getProductAddOns as clientGetProductAddOns } from 'typescript/clients/solidshop/products_client';
import { MUTATION_KEYS } from 'typescript/constants/react_query';

/**
 * Hook for getting product add-ons
 * @param options - optional parameters for the request
 * @returns mutation function and state for getting product add-ons
 */
const useAddOns = ({ locale, options }: { locale: string; options?: any }) => {
  const { mutate: getAddOns, ...rest } = useMutation({
    mutationKey: [MUTATION_KEYS.GET_PRODUCT_ADD_ONS, { options }],
    mutationFn: ({ productSlug }: { productSlug: string }) =>
      clientGetProductAddOns({
        locale,
        productSlug,
        options,
      }),
    onError: (error) =>
      captureException(
        new CustomError(MUTATION_KEYS.GET_PRODUCT_ADD_ONS, error),
        {
          extra: {
            locale,
            options,
          },
        },
      ),
  });

  return { getAddOns, ...rest };
};

export { useAddOns };
